export const API_EXTERNAL_ENDPOINT = 'users/login-google'

export const API_INTERNAL_ENDPOINT = 'rurality/v3/users/login-google'
